import { useTranslation } from "react-i18next";

const DocumentHeader = ({ onSort, sortByField, orderSortByField }) => {
  const { t } = useTranslation();

  const handleSort = (field) => {
    if (!onSort) return;
    if (sortByField === field) {
      onSort(field, orderSortByField === "1" ? "-1" : "1");
    } else {
      onSort(field, "1");
    }
  };

  const getSortIcon = (field) => {
    if (sortByField === field) {
      return orderSortByField === "1" ? "fa-sort-up" : "fa-sort-down";
    }
    return "fa-sort";
  };

  return (
    <article className="table-standard-header">
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("name")}
      >
        {t("Name")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("name")}`} aria-hidden />
        </span>
      </div>
      <div
        className="table-standard-header-cell"
        style={{ cursor: "pointer" }}
        onClick={() => handleSort("date")}
      >
        {t("Creation date")}
        <span className="sort-icon">
          <i className={`fas ${getSortIcon("date")}`} aria-hidden />
        </span>
      </div>
      <div className="table-standard-header-cell" />
    </article>
  );
};

export default DocumentHeader;
